<fgb-mobile-header-bar [title]="'challenges.page.title' | translate" [showPoints]="true" [link]="'/'"></fgb-mobile-header-bar>
<div class="banner d-none d-lg-flex" role="banner">
  <div class="container">
    <div class="title-wrapper">
      <img src="assets/images/banners/Challenges.png" alt="" />
    </div>
  </div>
</div>
<div class="mobile-content-wrapper mb-4">
  <div class="container badge-achieved-container">
    <fgbcl-badge-achieved />
  </div>
  <fgbcl-scorecard-list-view [icon]="'chevron_right'" [showPlaceholder]="true"></fgbcl-scorecard-list-view>
</div>
